module.exports = __webpack_public_path__ + "img/01b36db366d0545219883d30a5ba16b1.dcb96f7e.jpg";